import { render, staticRenderFns } from "./WaferLabelDialog.vue?vue&type=template&id=3ae23178&scoped=true"
import script from "./WaferLabelDialog.vue?vue&type=script&lang=js"
export * from "./WaferLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./WaferLabelDialog.vue?vue&type=style&index=0&id=3ae23178&prod&scoped=true&lang=css"
import style1 from "./WaferLabelDialog.vue?vue&type=style&index=1&id=3ae23178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae23178",
  null
  
)

export default component.exports